import type { ProviderDidPool } from "@/api/organization-did.api";
import type { OptionSelect } from "@/components/helpers/types";
import { formatPhoneNumber } from "@/utils/phone";

export function buildDidAreaCodeOptions(pool?: ProviderDidPool): OptionSelect[] {
  const areaCodes = new Set<string>();

  for (const did of pool?.dids ?? []) {
    areaCodes.add(did.ddd);
  }

  return [...areaCodes].sort((left, right) => left.localeCompare(right)).map((ddd) => ({
    value: ddd,
    label: ddd,
    textValue: ddd,
  }));
}

export function buildDidPoolNumbers(
  pool: ProviderDidPool | undefined,
  ddd: string | null,
): string[] {
  if (!ddd) return [];

  return (pool?.dids ?? [])
    .filter(did => did.ddd === ddd)
    .map(did => formatDidNumber(did.number))
    .sort((left, right) => left.localeCompare(right));
}

export interface DidPoolEntry {
  number: string;
  display: string;
}

export function buildDidPoolEntries(
  pool: ProviderDidPool | undefined,
  ddd: string | null,
): DidPoolEntry[] {
  if (!ddd) return [];

  return (pool?.dids ?? [])
    .filter(did => did.ddd === ddd)
    .map(did => ({ number: did.number, display: formatDidNumber(did.number) }))
    .sort((left, right) => left.display.localeCompare(right.display));
}

export function formatDidNumber(value: string): string {
  return formatPhoneNumber(value);
}
